exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog_text[data-v-372ecc56],.dialog_title[data-v-372ecc56]{display:flex;justify-content:center;flex-direction:column}.dialog_text[data-v-372ecc56]{padding:1.4rem}.dialog_buttons[data-v-372ecc56]{display:flex;justify-content:space-between}", ""]);

// exports
